import React from 'react';
import { PipelineNodeGraph } from 'react-scale/corp/components/Lookup/sections/PipelineV3Graphs';
import HideableSection from 'react-scale/corp/components/UI/HideableSection';
import { ISensorFusionSubstageInstanceLookupDto } from '@scale/sensor-fusion-shared';

type SubstageInstancePipelinePanelProps = {
  substageInstance: ISensorFusionSubstageInstanceLookupDto;
};

const SubstageInstancePipelinePanel = ({
  substageInstance,
}: SubstageInstancePipelinePanelProps) => {
  const hasPipelineNodes = !!substageInstance.pipelineNodes?.length;
  const hasLotsOfPipelineNodes = hasPipelineNodes && substageInstance.pipelineNodes!.length > 75;

  if (!hasPipelineNodes) return null;

  return (
    <HideableSection
      name="Pipeline Execution Overview Graph"
      forceHidden={hasLotsOfPipelineNodes}
      containZoom
    >
      <PipelineNodeGraph
        nodes={substageInstance.pipelineNodes!}
        executionId={substageInstance.pipelineExecutionId}
      />
    </HideableSection>
  );
};

export default SubstageInstancePipelinePanel;
